import React from 'react'
import { Theme, withStyles } from '@material-ui/core/styles'
import Dialog from '@material-ui/core/Dialog'
import MuiDialogContent from '@material-ui/core/DialogContent'
import MuiDialogActions from '@material-ui/core/DialogActions'
import { Grid, makeStyles } from '@material-ui/core'
import { isMobile } from 'react-device-detect'
import close from '../assets/images/close.svg'

const DialogContent = withStyles((theme: Theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent)

const DialogActions = withStyles((theme: Theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions)

interface ChartTooltipModalProps {
  open?: any
  setOpen?: any
  handleClose?: any
}
const useStyles = makeStyles({
  content: {
    background: '#FFFFFF',
    boxSizing: 'border-box',
    borderRadius: 3,
    padding: '24 24',
  },
  title: {
    color: '#3393F3',
    fontSize: 14,
    fontWeight: 600,
    textTransform: 'uppercase',
  },
  subTitle: {
    color: '#3393F3',
    fontSize: 12,
    fontWeight: 400,
  },
  detailContent: {
    marginBottom: 12,
  },
  header: {
    marginBottom: 12,
    '& input': {
      float: 'right',
    },
  },
  typeHead: {
    fontSize: 14,
    color: 'rgba(24, 24, 24, 1)',
    fontWeight: 600,
  },
  typeDetail: {
    fontWeight: 400,
    fontSize: 14,
  },
})

const BehaviouralTooltipModal = ({
  open,
  setOpen,
  handleClose,
}: ChartTooltipModalProps) => {
  const classes = useStyles()
  return (
    <div>
      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <DialogContent>
          <div className={classes.content}>
            {!isMobile && (
              <div className={classes.header}>
                <span className={classes.title}>Behavioural Panel </span>
                <span className={classes.subTitle}>
                  (Street Perception & Investor Confidence Measures)
                </span>
                <input
                  type="image"
                  onClick={() => handleClose()}
                  src={close}
                  alt="closeBtn"
                />
              </div>
            )}

            {isMobile && (
              <>
                <div className={classes.header} style={{ marginBottom: 5 }}>
                  <span className={classes.title}>Behavioural Panel </span>
                  <input
                    type="image"
                    onClick={() => handleClose()}
                    src={close}
                    alt="closeBtn"
                  />
                </div>
                <div className={classes.subTitle} style={{ marginBottom: 10 }}>
                  (Street Perception & Investor Confidence Measures)
                </div>
              </>
            )}

            <div className={classes.detailContent}>
              <span className={classes.typeHead}>Behavioural Analysis: </span>
              <span className={classes.typeDetail}>
                Perception is reality, when looking at risk it is important to
                track and understand if other market participants have pockets
                of better insights and are reflecting those into the outlook of
                the company. This can give a strong early warning of behaviour
                change in the investor and analyst community towards a target
                company. These charts in this panel are based around asking the
                Analyst and Investor community what they think about the company
                and identifying if they are changing their behaviours,
                conviction or perceptions. Just like you would make calls to
                your market “friends”, we make those calls on your behalf,
                through the data of 100’s of thousands of Analysts and
                Investors. We will speak to the data of more than 130,000 Global
                Analysts and 270,000 Active Investors.
              </span>
            </div>

            <div className={classes.detailContent}>
              <span className={classes.typeHead}>Earnings Risk: </span>
              <span className={classes.typeDetail}>
                We identify leading Analysts which we call “smart consensus” a
                group of 3 or more Analysts who have a strong track record above
                70% accuracy in forecasting the earnings of the company. We
                display this forward looking on either an annual or interim
                (quarterly or semi-annual basis) against the market consensus.
                This is a good way to identify if the smart part of the Analyst
                community is forecasting potential earnings weakness
              </span>
            </div>

            <div className={classes.detailContent}>
              <span className={classes.typeHead}>
                Equity & Bond Conviction:{' '}
              </span>
              <span className={classes.typeDetail}>
                These charts look at the behaviour of active investors, on the
                equity side, an index is built to track those active investors
                who have over allocated capital to the company versus their
                benchmark. If this declines it could signal that these over
                convicted investors are reducing their confidence in the company
                and pulling back their capital. On the bond side we track the
                top 25 bond holders across the curve, to give you a view of
                investor confidence in allocating capital to the companies
                bonds.
              </span>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  )
}

export default React.memo(BehaviouralTooltipModal)
